import styled from 'foundations-theming/utils';
import { breakpointValues } from 'pricing-pages-ui-components/constants/Breakpoints';
import { useLocation } from 'quartz-routing/react-router';
import PublicSideNav from '../components/PublicSideNav';
import { isPublicNavItem } from '../types/PublicNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MOBILE_EM = (breakpointValues.tablet - 1) / 16;

/*
 * CSS grid handles both layouts — desktop (side-by-side) and mobile (stacked).
 * Content is always in the DOM regardless of viewport so crawlers get full HTML.
 */
const AppGrid = styled.div.withConfig({
  displayName: "PublicAppLayout__AppGrid"
})(({
  theme
}) => ({
  inlineSize: '100%',
  maxInlineSize: '1528px',
  margin: 'auto',
  display: 'grid',
  gridTemplateAreas: '"side-nav content"',
  gridTemplateColumns: 'minmax(280px, auto) 1fr',
  columnGap: theme.space[400],
  rowGap: theme.space[400],
  paddingBlockStart: theme.space[400],
  paddingInline: theme.space[200],
  [`@media (max-width: ${MOBILE_EM}em)`]: {
    gridTemplateAreas: '"side-nav" "content"',
    gridTemplateColumns: '1fr',
    paddingBlockStart: '0',
    paddingInline: '0',
    rowGap: '0'
  }
}));

/*
 * minInlineSize: 0 prevents the grid track from expanding beyond its allocated
 * size when a descendant has wide content — standard CSS Grid containment pattern.
 */
const SideNavArea = styled.div.withConfig({
  displayName: "PublicAppLayout__SideNavArea"
})(({
  theme
}) => ({
  gridArea: 'side-nav',
  minInlineSize: 0,
  /*
   * MobileSideNav toggle bar uses marginInline="-200" to extend edge-to-edge
   * by negating the parent's paddingInline. Provide that 8px so mobile shows
   * no horizontal overflow and position:fixed overlay lands flush.
   */
  [`@media (max-width: ${MOBILE_EM}em)`]: {
    paddingInline: theme.space[200]
  }
}));
const ContentArea = styled.div.withConfig({
  displayName: "PublicAppLayout__ContentArea"
})(({
  theme
}) => ({
  gridArea: 'content',
  minInlineSize: 0,
  [`@media (max-width: ${MOBILE_EM}em)`]: {
    paddingBlockStart: theme.space[500]
  }
}));
/*
 * BaseLayout (HSGlobalNav header/footer) is hoisted up into PublicRootLayout
 * so it stays mounted across navigation. This component only owns the inner
 * sidenav + content shell.
 */
const PublicAppLayout = ({
  children
}) => {
  var _pathname$split$filte;
  const {
    pathname
  } = useLocation();
  const rawSlug = (_pathname$split$filte = pathname.split('/').filter(Boolean)[0]) !== null && _pathname$split$filte !== void 0 ? _pathname$split$filte : '';
  const slug = rawSlug === 'revenue' ? 'commerce' : rawSlug;
  const selectedNavItem = isPublicNavItem(slug) ? slug : 'marketing';
  return /*#__PURE__*/_jsxs(AppGrid, {
    children: [/*#__PURE__*/_jsx(SideNavArea, {
      children: /*#__PURE__*/_jsx(PublicSideNav, {
        selectedNavItem: selectedNavItem
      })
    }), /*#__PURE__*/_jsx(ContentArea, {
      children: children
    })]
  });
};
export default PublicAppLayout;